/**
 * Hook to transform UnifiedForecastResult to cumulative format
 *
 * DEPRECATED: Backend now provides both incremental and cumulative values
 * on every RebatePoint. Use the selector utility (getRebateAmount) instead
 * of transforming data.
 *
 * This hook is kept for backward compatibility but is now a no-op.
 * Components should use getRebateAmount(point, isCumulative) to select
 * which field to display.
 *
 * @deprecated Use getRebateAmount from '@/utils/rebateAmountSelector' instead
 */

import type { UnifiedForecastResult, RebatePoint } from '@erp/shared-types';

/**
 * Hook to transform forecast data to cumulative format if needed
 *
 * @deprecated This is now a no-op. Backend provides both incremental and cumulative
 * values. Use getRebateAmount(point, isCumulative) to select which field to display.
 *
 * @param forecastData - The forecast data (now contains both incremental and cumulative)
 * @param isCumulative - Ignored (kept for API compatibility)
 * @param lastRealEstimate - Ignored (kept for API compatibility)
 * @param predictionSplitDay - Ignored (kept for API compatibility)
 * @returns The original forecast data (no transformation)
 */
export function useCumulativeForecastData(
  forecastData: UnifiedForecastResult | null | undefined,
  _isCumulative: boolean,
  _lastRealEstimate: RebatePoint | null = null,
  _predictionSplitDay: number | null = null,
): UnifiedForecastResult | null | undefined {
  // No-op: Backend provides both values, components should use selector utility
  return forecastData;
}
